import React, { useEffect } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Link } from 'react-router-dom';

const RevenueTable = ({ tableData }) => {
    useEffect(() => {
        const table = $(`#dataTable-${tableData.id}`).DataTable({
            pageLength: 10,
            destroy: true, // Important to prevent duplicate tables
        });
        return () => {
            table.destroy(true);
        };
    }, [tableData]);

    return (
        <div className="card basic-data-table " style={{ marginTop: '27px' }}>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id={`dataTable-${tableData.id}`} // Unique ID for each table
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">Sr.#</th>
                            <th scope="col">Center Name</th>
                            <th scope="col">Revenue</th>
                            <th scope="col">Refund</th>
                            <th scope="col">Manager</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.data.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.centerName}</td>
                                <td><Link to="#" className="text-primary-600">{item.revenue}</Link></td>
                                <td><Link to="#" className="text-primary-600">{item.refund}</Link></td>
                                <td>{item.manager}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RevenueTable;
